import block from 'bem-cn'
import React from 'react'
import { shallowEqual, useSelector } from 'react-redux'

import { selectLocaleDict } from 'features/locale/selectors'

import { Loading } from './Loading'

interface IClock {
  timerDays: string
  timerHours: string
  timerMinutes: string
  timerSeconds: string
  isExpired: boolean
}

const b = block('bonus-clock')

export const Clock: React.FC<IClock> = ({ timerDays, timerHours, timerMinutes, timerSeconds, isExpired }) => {
  const locale = useSelector(selectLocaleDict, shallowEqual).bonuses
  const checkedDays = +timerDays ? `${timerDays}${locale.days}` : ''

  return (
    <div className={b()}>
      {isExpired ? (
        <Loading />
      ) : (
        <>
          {checkedDays && (
            <span className={b('time', { days: true })}>
              {`${checkedDays}`} <span className={b('slash')}> / </span>
            </span>
          )}
          <span className={b('time')}>{`${timerHours}:${timerMinutes}:${timerSeconds}`}</span>
        </>
      )}
    </div>
  )
}
